'use client';

import { parseHtmlWithStyledLinks } from '@/utils/parseHtmlWithStyledLinks';

import {
    LocalImage,
    type LocalImageProps,
} from '@/components/atoms/LocalImage';
import { P } from '@/components/atoms/Typography/P';

export interface ListItemProps {
    id: string | number;
    description: string;
    additionalText?: string;
    image: LocalImageProps;
    'data-test-id'?: string;
}

export default function ListItem({
    description,
    image,
    additionalText,
    'data-test-id': dataTestId,
}: ListItemProps) {
    return (
        // Added width to looking alike production
        <div
            className="mx-auto my-0 flex max-w-[320px] flex-col items-center pb-8 min-[560px]:w-full md:p-0"
            data-test-id={dataTestId}
        >
            <LocalImage
                className="mb-4 h-[128px] max-h-[128px]"
                width={128}
                height={128}
                {...image}
            />

            {additionalText && (
                <P
                    className="text-center text-purple-800"
                    dangerouslySetInnerHTML={{ __html: additionalText }}
                />
            )}

            <P className="mb-2 text-center">
                {parseHtmlWithStyledLinks(description)}
            </P>
        </div>
    );
}
